import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PageTogglerLayout",
  props: {
    showInformationPage: {
      type: Boolean,
      default: false
    }
  },
  setup() {}
});